// inventory-metrics.mapping.ts
export const INVENTORY_METRIC_MAPPING = {
  // Modal metric ID : inventory_aggregates field name
  // Changed from snake_case to camelCase to match API response format
  totalProducts: 'totalProducts',
  totalAvailableStock: 'totalAvailableStock',
  // inventoryValue: 'totalInventoryValue', // Removed - duplicate of totalCog
  totalEstSales: 'totalEstSales',
  totalEstProfit: 'totalEstProfit',
  totalCog: 'totalCog',
  totalShippingCost: 'totalShippingCost',
  totalEstMonthlyStorageFee: 'totalEstMonthlyStorageFee',
  avgRoi: 'avgRoi',
  totalUnitsSold30Days: 'totalUnitsSold30Days',
  totalUnitsSold90Days: 'totalUnitsSold90Days'
  // avgDaysLeft: 'avgDaysLeft' // Removed from backend
};

interface MetricDisplayInfo {
  title: string;
  icon: string;
  format: string;
  tooltip?: string;
}

interface MetricDisplayInfoMap {
  [key: string]: MetricDisplayInfo;
}

export const getInventoryMetricDisplayInfo = (metricId: string): MetricDisplayInfo => {
  // Added index signature to fix TypeScript error
  const displayInfo: { [key: string]: MetricDisplayInfo } = {
    totalProducts: { title: 'Total SKUs', icon: 'box', format: 'number' },
    totalAvailableStock: { title: 'Available Stock', icon: 'package', format: 'number' },
    // inventoryValue: { title: 'Inventory Value', icon: 'dollar-sign', format: 'currency' }, // Removed - duplicate of totalCog
    totalEstSales: { title: 'Estimated Sales', icon: 'trending-up', format: 'currency' },
    totalEstProfit: { title: 'Estimated Profit', icon: 'pie-chart', format: 'currency' },
    totalCog: { title: 'Total COG', icon: 'shopping-bag', format: 'currency' },
    totalShippingCost: { title: 'Total Shipping Cost', icon: 'truck', format: 'currency' },
    totalEstMonthlyStorageFee: {
      title: 'Estm. Monthly Storage & Fulfillment Fees',
      icon: 'archive',
      format: 'currency',
      tooltip:
        'Total estimated monthly storage and fulfillment fees for all inventory (FBT storage + FBS storage + FBS fulfillment)'
    },
    avgRoi: {
      title: 'Average ROI',
      icon: 'percent',
      format: 'percent',
      tooltip:
        'Weighted average ROI based on Total COG. Formula: Σ(ROI × COG weight) where weight = SKU COG / Total COG. Only includes SKUs with Unit COG set.'
    },
    totalUnitsSold30Days: {
      title: 'Total Units Sold (30 Days)',
      icon: 'shopping-cart',
      format: 'number'
    },
    totalUnitsSold90Days: {
      title: 'Total Units Sold (90 Days)',
      icon: 'shopping-cart',
      format: 'number'
    }
    // avgDaysLeft: { title: 'Avg Days Left', icon: 'calendar', format: 'number' } // Removed from backend
  };

  return (
    displayInfo[metricId] || {
      title: metricId,
      icon: 'info',
      format: 'number'
    }
  );
};
